/**
 * Be careful with this enum
 * This is used in the customer-svc database as an enum value
 */
export enum OrderStatus {
  /**
   * Pickup Event Types
   */
  PickupPreparing = 'pickup.preparing',
  PickupReceived = 'pickup.received',
  PickupCompleted = 'pickup.completed',
  PickupFailed = 'pickup.failed',
  PickupPreorderFailed = 'pickup.preorder_failed',
  PickupCanceled = 'pickup.canceled',
  PickupUnknown = 'pickup.unknown',
  PickupLate = 'pickup.late',

  /**
   * Outpost Event Types
   */
  OutpostReceived = 'outpost.received',
  OutpostRouteToPickup = 'outpost.en_route_to_pickup',
  OutpostRouteToBatchedDropoff = 'outpost.en_route_to_batched_dropoff',
  OutpostRouteToDropoff = 'outpost.en_route_to_dropoff',
  OutpostCompleted = 'outpost.completed',
  OutpostFailed = 'outpost.failed',
  OutpostPreorderFailed = 'outpost.preorder_failed',
  OutpostCanceled = 'outpost.canceled',
  OutpostLate = 'outpost.late',
  OutpostUnknown = 'outpost.unknown',

  /**
   * Delivery Event Types
   */
  DeliveryReceived = 'delivery.received',
  DeliveryPreparing = 'delivery.preparing',
  DeliveryReadyForCourier = 'delivery.ready_for_courier',
  DeliveryRouteToPickup = 'delivery.en_route_to_pickup',
  DeliveryArrivedAtPickup = 'delivery.arrived_at_pickup',
  DeliveryRouteToBatchedDropoff = 'delivery.en_route_to_batched_dropoff',
  DeliveryRouteToDropoff = 'delivery.en_route_to_dropoff',
  DeliveryArrivedAtDropoff = 'delivery.arrived_at_dropoff',
  DeliveryCompleted = 'delivery.completed',
  DeliveryFailed = 'delivery.failed',
  DeliveryPreorderFailed = 'delivery.preorder_failed',
  DeliveryCanceled = 'delivery.canceled',
  DeliveryLate = 'delivery.late',
  DeliveryUnknown = 'delivery.unknown',

  /**
   * Catering Event Types
   */
  CateringReceived = 'catering.received',
  CateringPreparing = 'catering.preparing',
  CateringCompleted = 'catering.completed',
  CateringFailed = 'catering.failed',
  CateringCanceled = 'catering.canceled',
  CateringUnknown = 'catering.unknown',

  /**
   * In-Store Event Types
   */
  InStoreCompleted = 'in_store.completed',

  /**
   * Unknown Event Types
   */
  UnknownUnknown = 'unknown.unknown',
}
